import { render } from "./NotesDrawerButton.vue?vue&type=template&id=2cbdf5dd"
import script from "./NotesDrawerButton.vue?vue&type=script&lang=js"
export * from "./NotesDrawerButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__